import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { IPotentialSavingsDTO } from '@modules/potential-save-modal/dto/i-potential-savings.dto';
import { PotentialSavingsService } from '@modules/potential-save-modal/potential-savings.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-refresh-potential-savings',
	templateUrl: './refresh-potential-savings.component.html',
	styleUrls: ['./refresh-potential-savings.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshPotentialSavingsComponent {
	public readonly potentialSavings$: Observable<IPotentialSavingsDTO> = this.potentialSavingsService.potentialSavings$;

	constructor(
		private potentialSavingsService: PotentialSavingsService,
		private dialogRef: MatDialogRef<RefreshPotentialSavingsComponent>,
		private toastService: WrapToasterService,
	) {}

	public cancelAction(): void {
		this.dialogRef.close();
	}

	public refresh(): void {
		this.potentialSavingsService
			.refreshPotentialSavings()
			.pipe(take(1))
			.subscribe(
				() => {
					this.toastService.showToast('success', 'Success', 'Potential Savings refresh action was launched.');
					this.dialogRef.close();
				},
				(err: HttpErrorResponse) => {
					this.toastService.showToast('error', 'Error!', err.error.message);
				},
			);
	}
}
